import type {
	BankProductCreateFormInput,
	BankProductEditFormInput,
} from "web_myplann/Portfolio/Forms/BankProductForm/bankProductFormSchema";

export const BANK_PRODUCT_EDIT_FORM_DEFAULT_VALUES: BankProductEditFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	signedAt: null,
	startAt: null,
	endAt: null,
	tools: [],
};

export const BANK_PRODUCT_CREATE_FORM_DEFAULT_VALUES: BankProductCreateFormInput =
	{
		...BANK_PRODUCT_EDIT_FORM_DEFAULT_VALUES,
		value: null,
		invested: null,
		valueDate: null,
	};

export const getBankProductCreateFormDefaultValues =
	(): BankProductCreateFormInput => ({
		...BANK_PRODUCT_CREATE_FORM_DEFAULT_VALUES,
		valueDate: new Date(),
	});
